module.exports = __webpack_public_path__ + "img/cedula-back.fc92ad2f.png";